import React, {useMemo} from "react";
import type {  OptionProps } from "react-select";
import { components } from "react-select";
import Select from "@/components/ui/Select";
import { countryList } from "./countries.constant";
import Avatar from "@/components/ui/Avatar/Avatar";
import CountryPhoneCustomSelectOption, {
  CountryOption,
} from "@/components/form/CountryPhoneCustomSelectOption";
import type {TypeAttributes} from "@/components/ui/@types/common";

const { Control } = components;

export default function CountryDialcodeSelectionControlled(p: {
  appendNameToReturnValue?: boolean; // default false. If true, then the value returned is countryCode_countryName (e.g. "US_United States")
  field: {
    value: string | undefined;
    onChange(value: string | undefined): void;
  };
  size?: TypeAttributes.ControlSize;
  disabled?: boolean
  countryPlaceholder: string;
}) {

  const dialCodeList = useMemo(() => {
    return countryList.map((country) => ({
      ...country,
      label: country.dialCode, // don't mutate original
    }));
  }, []);

  const wal = useMemo(()=>{
    return dialCodeList.find(i => i.dialCode == (p.field.value??"").trim())
  },[p.field.value])

  const src = useMemo(() => {
    if(wal){
      return `/img/countries/${wal.value}.png`
    } else {
      return undefined
    }
  },[wal])

  const CustomControl = useMemo(() => {
    return ({ children, ...rest }: any) => (
      // @ts-expect-error F*ck I dont know
      <Control {...rest}>
        {wal && (
          <Avatar
            key={wal.value}
            className="ltr:ml-4 rtl:mr-4"
            shape="circle"
            size={20}
            src={src}
          />
        )}
        {children}
      </Control>
    );
  }, [wal, src]);

  return (
    <Select<CountryOption>
      isDisabled={p.disabled === true}
      options={dialCodeList}
      size={p.size}
      {...p.field}
      className="w-[250px]"
      components={{
        Option: (props) => (
          <CountryPhoneCustomSelectOption
            variant="phone"
            {...(props as OptionProps<CountryOption>)}
          />
        ),
        Control:  CustomControl
      }}
      placeholder={p.countryPlaceholder}
      value={wal}
      onChange={(option) =>
        p.field.onChange(option?.dialCode)
      }
    />

  );
}

